import { OnInit, inject } from '@angular/core';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavService } from 'src/app/common/services/nav/nav.service';
import { UtilService } from 'src/app/common/services/util/util.service';
import { ProjectConstants } from 'src/assets/constants/project.constants';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {
  model: any[] = [];
  adminModel: any[] = [];
  projectConstants = ProjectConstants;
  subscriptions = new Subscription();
  private navService = inject(NavService);
  private utilService = inject(UtilService);

  // ngOnInit() {
  //     this.getAllNavItems();
  // }

  getAllNavItems(): void {
    this.subscriptions.add(
      this.navService.getAllNavItems().subscribe({
        next: (res) => {
          this.model = res.result;
        },
        complete: () => {}
      })
    );
  }

  isActive = true;

  ngOnInit() {
    this.getAllMenuItems();
    this.updateMenuOnChange();
    // this.recreateDefaultMenu();

    // this.model = [
    //     {
    //         label: 'Home',
    //         icon: 'pi pi-home',
    //         items: [
    //             {
    //                 label: 'Dashboard',
    //                 icon: 'pi pi-fw pi-home',
    //                 routerLink: ['/'],
    //             },
    //             {
    //                 label: 'Messages <p-tag value="New" />',
    //                 escape: false,
    //                 icon: 'pi pi-fw pi-envelope',
    //                 command: () => {
    //                 }
    //             },
    //         ],
    //     },

    //     {
    //         label: 'Briefcase',
    //         icon: 'pi pi-briefcase',
    //         items: [
    //             {
    //                 label: 'Board Packs',
    //                 icon: 'pi pi-list',
    //                 routerLink: ['/folder/list'],
    //             },
    //             {
    //                 label: 'Documents',
    //                 icon: 'pi pi-file',
    //                 routerLink: ['/documents'],
    //             },
    //             {
    //                 label: 'Business Reports',
    //                 icon: 'pi pi-chart-line',
    //                 routerLink: ['/reports'],
    //             },

    //             {
    //                 label: 'My Notes',
    //                 icon: 'pi pi-book',
    //                 routerLink: ['/notes'],
    //             },
    //         ],
    //     },
    //     {
    //         label: 'Calendar & Meetings',
    //         icon: 'pi pi-calendar',
    //         items: [
    //             {
    //                 label: 'Meetings',
    //                 icon: 'pi pi-link',
    //                 routerLink: ['/meetings/my-meetings'],
    //             },
    //             {
    //                 label: 'Calendar',
    //                 icon: 'pi pi-calendar',
    //                 routerLink: ['/calendar'],
    //             },
    //             // {
    //             //     label: 'eVoting & Polls',
    //             //     icon: 'pi pi-database ',
    //             //     routerLink: ['/polls']
    //             // },
    //         ],
    //     },
    //     {
    //         label: 'Actions',
    //         icon: 'pi pi-user-plus',
    //         items: [
    //             {
    //                 label: 'Action Points',
    //                 icon: 'pi pi-list',
    //                 routerLink: ['/action-points'],
    //             },
    //             // {
    //             //     label: 'Approvals',
    //             //     icon: 'pi pi-check-circle',
    //             //     routerLink: ['/approvals'],
    //             // },
    //         ],
    //     },
    //     {
    //         label: 'Notifications',
    //         icon: 'pi pi-home',
    //         items: [
    //             {
    //                 label: 'Notifications',
    //                 icon: 'pi pi-bell',
    //                 routerLink: ['/notifications'],
    //             },
    //         ],
    //     },
    //     {
    //         label: 'Manage',
    //         icon: 'pi pi-cog',
    //         items: [
    //             {
    //                 label: 'Users',
    //                 icon: 'pi pi-users',
    //                 routerLink: ['/users/list'],
    //             },
    //             {
    //                 label: 'Committees',
    //                 icon: 'pi pi-server',
    //                 routerLink: ['/group/group-list'],
    //             },
    //             {
    //                 label: 'Organizations',
    //                 icon: 'pi pi-cog',
    //                 routerLink: ['/organization/select'],
    //             },
    //             {
    //                 label: 'Feedback/Request',
    //                 icon: 'pi pi-sign-in',
    //                 routerLink: ['/feedback/manage-feedback'],
    //             },
    //         ],
    //     },
    // ];

    this.adminModel = [
      {
        label: 'Manage',
        icon: 'pi pi-cog',
        items: [
          {
            label: 'Users',
            icon: 'pi pi-users',
            routerLink: ['/users/list']
          },
          {
            label: 'Organizations',
            icon: 'pi pi-cog',
            routerLink: ['/organization/select']
          },
          {
            label: 'Pending Requests',
            icon: 'pi pi-sign-in',
            routerLink: ['/organization/pending-requests']
          }
        ]
      }
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async checkForRole() {
    if (await this.utilService.checkForRole(['SYSADMIN'])) {
      this.model = [...this.model, ...this.adminModel];
    }
  }

  getAllMenuItems(): void {
    this.subscriptions.add(
      this.navService.getNavLicensedItemsByRoles().subscribe({
        next: (res) => {
          this.model = res.result;
        }
      })
    );
  }

  updateMenuOnChange(): void {
    this.subscriptions.add(
      this.navService.trigger$.subscribe(() => {
        this.getAllMenuItems();
      })
    );
  }

  recreateDefaultMenu(): void {
    this.subscriptions.add(
      this.navService.recreateDefaultMenu().subscribe({
        next: (res) => {}
      })
    );
  }
}
